export { EBackground } from 'shared/repositories/search-engine/entities/moderation_info/PhotoStubSchema';

export type { IPhotoStubSchema as IPhotoStub } from 'shared/repositories/search-engine/entities/moderation_info/PhotoStubSchema';

export interface IOfferPessimization {
  /** Текст на фото **/
  text: string;
  /** Тип пессимизации **/
  type: EOfferPessimizationType;
}

export enum EOfferPessimizationType {
  /** Легкая пессимизация **/
  Light = 'light',
  /** Сильная пессимизация **/
  Strong = 'strong',
}

export interface IPessimization {
  background: EPessimizationBackground;
  text: string;
}

export enum EPessimizationBackground {
  Gray = 'gray',
  Red = 'red',
}
